import { REPORT } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { average, countUnique } from '@utils/summaries';
import { basicSort } from '@utils/sort';

export const LocationsOverWarrantyRate = () => {
    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.ISSUES_LOCATIONS_WITH_OVER_FIFTY_PERCENTAGE_WARRANTY_RATE,
        params: {},
    });

    return (
        <BaseReport
            title={'Locations with Over 50% Warranty Rate'}
            rangeText={'All Time'}
            description={
                'This is a list of locations which have a warranty rate greater than 50%. Locations with high warranty rates often are an indication of employee theft.'
            }
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Location Name', 'Reseller Name', 'Warranty Rate %'],
                data: data.map((item) => [item.locationName, item.resellerName, item.warrantyRatePct]),
                summaries: [countUnique, countUnique, average],
                sort: [basicSort, basicSort, basicSort],
            }}
        />
    );
};
